// api/promoCodes.ts
import { API_BASE, getAuthHeaders } from './config';

export type PromoCode = {
    id: number;
    code: string;
    description?: string | null;

    // Co robi kod:
    // PREMIUM_MONTH = grant premium na określoną liczbę miesięcy (pole `months`)
    benefit_type: 'PREMIUM_MONTH';

    // Okres ważności samego kodu (od-do); opcjonalne
    starts_at?: string | null;
    expires_at?: string | null;

    // Ile razy maksymalnie kod może zostać zrealizowany (null = bez limitu)
    max_redemptions?: number | null;

    is_active: boolean;
    created_at: string;

    // Parametry granta:
    // ile miesięcy premium od momentu REDEEM
    months?: number | null;
    // plan premium (mapuje się na liczbę profili itp.)
    plan_type?: 'BASIC' | 'STANDARD' | 'FAMILY' | null;
    // opcjonalnie możesz mieć w bazie max_profiles, ale backend tego może nie używać
    max_profiles?: 1 | 2 | 4 | null;
};

export type PromoRedemption = {
    id: number;
    user_id: string;
    email: string;
    redeemed_at: string;
};

export async function adminFetchPromoCodes(params?: {
    query?: string;
    active?: 'any' | 'true' | 'false';
}) {
    const qp = new URLSearchParams();
    if (params?.query) qp.set('query', params.query);
    if (params?.active) qp.set('active', params.active);

    const res = await fetch(`${API_BASE}/admin/promo-codes?${qp.toString()}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{ items: PromoCode[] }>;
}

export async function adminCreatePromoCode(payload: Partial<PromoCode>) {
    const res = await fetch(`${API_BASE}/admin/promo-codes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<PromoCode>;
}

export async function adminUpdatePromoCode(
    id: number,
    payload: Partial<PromoCode>
) {
    const res = await fetch(`${API_BASE}/admin/promo-codes/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<PromoCode>;
}

export async function adminDeletePromoCode(id: number) {
    const res = await fetch(`${API_BASE}/admin/promo-codes/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{ ok: true }>;
}

export async function adminFetchPromoCodeRedemptions(id: number) {
    const res = await fetch(
        `${API_BASE}/admin/promo-codes/${id}/redemptions`,
        { headers: getAuthHeaders() }
    );
    if (!res.ok) throw await res.json();
    return res.json() as Promise<PromoRedemption[]>;
}

export async function redeemPromoCode(code: string) {
    const res = await fetch(`${API_BASE}/promo-codes/redeem`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify({ code }),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}
